import qs from 'query-string';
import { ContentType, getMimeType, } from './ContentType';
const fetchOptions = {
    credentials: 'same-origin',
};
export function assembleRequestGET(acceptContentType, additionalOptions) {
    const headers = assembleHeaders(acceptContentType, null, additionalOptions);
    return Object.assign(Object.assign({}, fetchOptions), { method: 'GET', headers: headers });
}
export function assembleRequestWithBody(method, bodyContentObj, acceptContentType, additionalOptions) {
    if (typeof (bodyContentObj) === "string") {
        const headers = assembleHeaders(acceptContentType, ContentType.Text, additionalOptions);
        return Object.assign(Object.assign({}, fetchOptions), { method: method, headers: headers, body: bodyContentObj });
    }
    else {
        const headers = assembleHeaders(acceptContentType, ContentType.Json, additionalOptions);
        return Object.assign(Object.assign({}, fetchOptions), { method: method, headers: headers, body: JSON.stringify(bodyContentObj) });
    }
}
export function assembleEndpoint(endpoint, additionalOptions) {
    if (additionalOptions && additionalOptions.params) {
        const stringifiedQueryParams = qs.stringify(additionalOptions.params);
        return `${endpoint}?${stringifiedQueryParams}`;
    }
    else {
        return endpoint;
    }
}
export function assembleHeaders(acceptContentType, requestContentType, additionalOptions) {
    const fetchHeaders = getFetchHeader(acceptContentType, requestContentType);
    if (additionalOptions && additionalOptions.headers) {
        return Object.assign(Object.assign({}, fetchHeaders), additionalOptions.headers);
    }
    else {
        return fetchHeaders;
    }
}
export function getFetchHeader(acceptContentType, requestContentType) {
    let fetchHeaders = {
        "Accept": getMimeType(acceptContentType),
    };
    if (requestContentType != null) {
        fetchHeaders["Content-Type"] = getMimeType(requestContentType);
    }
    return fetchHeaders;
}
//# sourceMappingURL=RestServiceHelpers.js.map